import React from 'react';
import { Document } from '@contentful/rich-text-types';

import { Box } from '../Box';
import { UnstyledButton } from '../Button';
import RichText from '../RichText';
import CollapsibleContainer from './CollapsibleContainer';

import { ToggleWrapper, ToggleIcon } from './styles';

import plus from '@/images/plus-primary.svg';

interface Props {
  title: string;
  content?: Document;
  isOpen: boolean;
  onClick?: () => void;
}

export function Collapsible({
  title,
  content,
  isOpen,
  onClick = () => null
}: Props) {
  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    // Check if the key pressed is 'Enter'
    if (event.key === 'Enter') {
      onClick();
    }
  };

  return (
    <div className="border-t border-solid border-[#d0d0d0] py-7 tablet:py-8 [&:last-child]:pb-0">
      <div
        className="flex cursor-pointer items-center justify-between"
        onClick={onClick}
        onKeyDown={handleKeyPress}
        tabIndex={0}
        role="button"
        aria-pressed={isOpen}
      >
        <div className="heading-3 tablet:!text-xl">{title}</div>
        <Box
          paddingLeft={{ 0: 's', tablet: 'm' }}
          paddingTop={{ 0: 's', tablet: 'xs' }}
        >
          <UnstyledButton onClick={onClick} data-testid="collapsible-btn">
            <ToggleWrapper>
              <ToggleIcon
                src={plus}
                alt={isOpen ? 'Close section' : 'Open section'}
                isOpen={isOpen}
              />
            </ToggleWrapper>
          </UnstyledButton>
        </Box>
      </div>
      {isOpen && (
        <CollapsibleContainer>
          <Box paddingTop={{ 0: 'sm' }}>
            {content && (
              <RichText
                data={content}
                bulletColor="green"
                data-testid="collapsible-body-text"
              />
            )}
          </Box>
        </CollapsibleContainer>
      )}
    </div>
  );
}
